import { ThemedVideo } from '@/routes/_landing/-components/themed-video'

export function Feature(props: {
  title: string
  Icon: React.ComponentType<{ className?: string }>
  description: string
  video: string
  videoDark: string
  image: string
  imageDark: string
  width: number
  height: number
  link: {
    text: string
    url: string
  }
}) {
  return (
    <section className="mx-auto mb-30 flex max-w-270 justify-center max-md:mb-7.5 [&:nth-child(2n+1)>div]:flex-row-reverse max-md:[&>div]:flex-col!">
      <div className="flex items-center gap-12">
        <div className="flex w-100 min-w-[40%] flex-col p-7.5 max-md:w-full max-md:min-w-0 max-md:p-5">
          <props.Icon className="mb-2.5 h-10 w-10" />
          <h2 className="mb-2.5 text-3xl font-semibold">{props.title}</h2>
          <p className="mb-7.5 text-xl">{props.description}</p>
          <a href={props.link.url} className="text-primary font-semibold">
            {props.link.text}
          </a>
        </div>

        <ThemedVideo
          light={props.video}
          dark={props.videoDark}
          posterLight={props.image}
          posterDark={props.imageDark}
          className="rounded-lg object-cover shadow-2xl max-md:h-auto! max-md:w-full!"
          style={{ width: props.width, height: props.height }}
        />
      </div>
    </section>
  )
}
